import {useSyncExternalStore} from 'react';
import {isEmailStockMediaPopupOpen, subscribeToEmailStockPopupOpenState} from '@EmailMakerReact/components/email-stock-media-popup/email-stock-popup-controller';

/** Whether the email editor's floating stock/AI media popup is currently open (any of its views: stock grid, AI generators, media choosers). */
export function useIsEmailStockPopupOpen(): boolean {
  return useSyncExternalStore(subscribeToEmailStockPopupOpenState, isEmailStockMediaPopupOpen);
}
